const user = {
  login: 'gaearon',
  id: 810438,
  node_id: 'MDQ6VXNlcjgxMDQzOA==',
  avatar_url: 'https://avatars.githubusercontent.com/u/810438?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/gaearon',
  html_url: 'https://github.com/gaearon',
  followers_url: 'https://api.github.com/users/gaearon/followers',
  following_url: 'https://api.github.com/users/gaearon/following{/other_user}',
  gists_url: 'https://api.github.com/users/gaearon/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/gaearon/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/gaearon/subscriptions',
  organizations_url: 'https://api.github.com/users/gaearon/orgs',
  repos_url: 'https://api.github.com/users/gaearon/repos',
  events_url: 'https://api.github.com/users/gaearon/events{/privacy}',
  received_events_url: 'https://api.github.com/users/gaearon/received_events',
  type: 'User',
  site_admin: false,
  name: 'Dan Abramov',
  company: '@facebook ',
  blog: '',
  location: null,
  email: null,
  hireable: null,
  bio: null,
  twitter_username: 'dan_abramov',
  public_repos: 255,
  public_gists: 73,
  followers: 70616,
  following: 172,
  created_at: '2011-05-25T18:18:31Z',
  updated_at: '2021-12-07T18:11:18Z',
};

export default user;
